module.exports = "<textarea [(ngModel)]='value' (ngModelChange)='onchange($event)' #editor id=\"editor\" name=\"editor\"></textarea>\r\n"